import { render } from "./Usuarios.vue?vue&type=template&id=4bc93ffc"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"
script.render = render

export default script